import { nest, compose } from 'recompose'
import { textSearchFilters } from '@infotech/filters'
import pickBy from 'lodash/pickBy'
import keyBy from 'lodash/keyBy'
import values from 'lodash/values'
import uniq from 'lodash/uniq'
import keys from 'lodash/keys'
import memoize from 'lodash/memoize'
import {
  InputHelper,
  WithTitle,
  reduxFormAdapterFrom,
  withDebounce,
  reduxFormAdapterTo,
  Input,
} from '@infotech/base-components'
import {
  fieldApps,
  typesConf,
  getAppConfigurator,
  fieldTypes,
  BODY,
} from '@infotech/view-config'
import { createGetColumnsConf } from '@infotech/crud'
import {
  journalModuleDefaultViewList,
  journalModuleDefaultFilterList,
  journalModuleDefaultFormList,
  journalModuleDefaultColumnsList,
  journalModuleDefaultFormListEdit,
  journalModuleFieldsConf,
} from '@infotech/energy-link-front-core'

import EquipmentClassFormatter from 'components/EquipmentClassFormatter'
import EquipmentNameFormatter from 'components/EquipmentNameFormatter'
import EquipmentAutoComplete from 'components/EquipmentAutoComplete'
import EquipmentField from 'components/EquipmentField'
import EquipmentViewFormatter from 'components/EquipmentViewFormatter'
import { IssueLinkSelect } from 'components/LinkedEsuzIssue'

const fieldsConf = {
  ...journalModuleFieldsConf,
  objectId: {
    type: fieldTypes.TEXT,
    name: `Оборудование`,
    apps: {
      [fieldApps.FORM]: {
        place    : BODY,
        title    : `Оборудование`,
        component: nest(InputHelper, EquipmentField),
      },
      [fieldApps.FILTER]: {
        title    : `Оборудование`,
        component: nest(InputHelper, EquipmentAutoComplete),
      },
    },
  },
  object: {
    type: fieldTypes.TEXT,
    name: `Оборудование`,
    apps: {
      [fieldApps.VIEW]: {
        place    : BODY,
        component: nest(WithTitle, EquipmentViewFormatter),
        title    : `Оборудование`,
      },
      [fieldApps.COLUMN]: {
        name     : `Оборудование`,
        sortable : true,
        width    : 250,
        formatter: EquipmentNameFormatter,
      },
    },
  },
  objectClass: {
    type: fieldTypes.TEXT,
    name: `Класс напряжения объекта`,
    apps: {
      [fieldApps.VIEW]: {
        place    : BODY,
        component: nest(WithTitle, EquipmentClassFormatter),
        title    : `Класс напряжения объекта`,
      },
    },
  },
  esuzNumber: {
    name: `Связанная заявка`,
    type: fieldTypes.TEXT,
    apps: {
      [fieldApps.FORM]: {
        place    : BODY,
        title    : `Связанная заявка`,
        component: nest(InputHelper, IssueLinkSelect),
      },
      [fieldApps.FILTER]: {
        title    : `Связанная заявка`,
        component: compose(
          reduxFormAdapterFrom,
          withDebounce,
          reduxFormAdapterTo,
        )(Input),
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
    },
  },
}


export const defaultFormList = [
  ...journalModuleDefaultFormList,
  `objectId`,
  `esuzNumber`,
]

export const defaultColumnsList = [
  ...journalModuleDefaultColumnsList,
  `esuz`,
]

export const defaultViewList = [
  ...journalModuleDefaultViewList.slice(0, 10),
  `object`,
  `objectClass`,
  ...journalModuleDefaultViewList.slice(10),
]

export const defaultFormListEdit = [
  ...journalModuleDefaultFormListEdit.slice(0, 10),
  `objectId`,
  `objectClass`,
  ...journalModuleDefaultFormListEdit.slice(10),
  `esuzNumber`,
]

export const defaultFilterList = [
  ...journalModuleDefaultFilterList,
  `objectId`,
  `esuzNumber`,
]

export const appsConf = (fieldsConfig) => getAppConfigurator(fieldsConfig, typesConf)

export const getColumnsConf = memoize((
  fieldsList = defaultColumnsList,
  fieldsConfig = fieldsConf,
) => createGetColumnsConf(
  appsConf(fieldsConfig)(fieldApps.COLUMN),
  fieldsList,
), (...args) => JSON.stringify(args))

export const getViewConfig = memoize((
  fieldsList = defaultViewList,
  fieldsConfig = fieldsConf,
) => fieldsList.map(appsConf(fieldsConfig)(fieldApps.VIEW)), (...args) => JSON.stringify(args))

export const getFormConfig = memoize((
  fieldsList = defaultFormList,
  fieldsConfig = fieldsConf,
) => keyBy(fieldsList.map(appsConf(fieldsConfig)(fieldApps.FORM)), `key`), (...args) => JSON.stringify(args))

export const getFilterConfig = memoize((
  fieldsList = defaultFilterList,
  fieldsConfig = fieldsConf,
) => keyBy(fieldsList.map(appsConf(fieldsConfig)(fieldApps.FILTER)), `key`), (...args) => JSON.stringify(args))

const getFullFieldsConfForApp = ({ metadata = [], fieldsConfig, app }) => {
  const allFieldsList = uniq([...keys(fieldsConfig), ...metadata.map(({ code }) => code)])
  const config = keyBy(allFieldsList.map(appsConf(fieldsConfig)(app)), `key`)

  // TODO: Разобраться, что делать с полями без названия
  return pickBy(config, (item) => item.name || item.title || item.label)
}

// eslint-disable-next-line
export const getAllColumns = memoize((fieldsList = defaultColumnsList, fieldsConfig = fieldsConf, metadata = []) => {
  const fullConfig = getFullFieldsConfForApp({ metadata, app: fieldApps.COLUMN, fieldsConfig })

  return values(fullConfig)
}, (...args) => JSON.stringify(args))
